import { useEffect, useState } from "react";
import { useLanguage } from "../../../context/LanguageContext";
import { useAlert } from "../../../Hooks/useAlert";
import { allowanceAPI } from "../../../services/api";
import settingsLanguage from "../../../language/settingsLanguage";
import Alert from "../../common/Alert";
import BackButton from "./BackButton";

function AllowancePage() {
  const { language } = useLanguage();
  const text = settingsLanguage[language];
  const { showAlert, alertConfig } = useAlert();
  const [loading, setLoading] = useState(false);
  const [allowances, setAllowances] = useState({
    transportAllowance: "",
    packingAllowance: "",
    otherAllowance: "",
  });

  useEffect(() => {
    loadAllowances();
  }, []);

  const loadAllowances = async () => {
    try {
      setLoading(true);
      const response = await allowanceAPI.getAllowances();
      if (response.success && response.data) {
        setAllowances({
          transportAllowance: response.data.transportAllowance || "",
          packingAllowance: response.data.packingAllowance || "",
          otherAllowance: response.data.otherAllowance || "",
        });
      }
    } catch (error) {
      console.error("Error loading allowances:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setAllowances((prev) => ({ ...prev, [field]: value }));
    }
  };

  const handleSaveAllowances = async () => {
    setLoading(true);
    try {
      const response = await allowanceAPI.saveAllowances({
        transportAllowance: parseFloat(allowances.transportAllowance) || 0,
        packingAllowance: parseFloat(allowances.packingAllowance) || 0,
        otherAllowance: parseFloat(allowances.otherAllowance) || 0,
      });

      if (response.success) {
        await showAlert({
          type: "success",
          title: "Success",
          message: "Allowances saved successfully!",
        });
      } else {
        await showAlert({
          type: "error",
          title: "Error",
          message: response.message || "Failed to save allowances.",
        });
      }
    } catch (error) {
      console.error("Error saving allowances:", error);
      await showAlert({
        type: "error",
        title: "Error",
        message: "Error saving allowances.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <header className="settings-page-header">
        <BackButton to="/settings" section="master" />
        <h1 className="settings-page-title">{text.allowanceMaster}</h1>
      </header>

      <main className="settings-page-content">
        <div className="settings-form-card">
          <div className="settings-form-body">
            <div className="settings-form-group">
              <label className="settings-form-label">{text.transportAllowance}</label>
              <input
                type="text"
                value={allowances.transportAllowance}
                onChange={(e) => handleInputChange("transportAllowance", e.target.value)}
                className="settings-form-input"
                placeholder="0.00"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">{text.packingAllowance}</label>
              <input
                type="text"
                value={allowances.packingAllowance}
                onChange={(e) => handleInputChange("packingAllowance", e.target.value)}
                className="settings-form-input"
                placeholder="0.00"
              />
            </div>

            <div className="settings-form-group">
              <label className="settings-form-label">{text.otherAllowance}</label>
              <input
                type="text"
                value={allowances.otherAllowance}
                onChange={(e) => handleInputChange("otherAllowance", e.target.value)}
                className="settings-form-input"
                placeholder="0.00"
              />
            </div>

            <div className="settings-form-actions">
              <button
                type="button"
                onClick={handleSaveAllowances}
                disabled={loading}
                className="settings-form-btn"
              >
                <i className="fas fa-save" />
                <span>{loading ? text.saving : text.saveAllowances}</span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {alertConfig && <Alert {...alertConfig} />}
    </div>
  );
}

export default AllowancePage;
